import $fetch from "./fetch";

export const apiBidSearchParam = () => {
    return $fetch('/system/menu/bid_search_param');
}

export const apiOverview = () => {
    return $fetch('/home/overview');
};